module.exports = __webpack_public_path__ + "static/media/ShanghaiMahjong.8053df2f.jpg";